import { render, staticRenderFns } from "./ModelAddCard.vue?vue&type=template&id=5d72d97c&scoped=true"
import script from "./ModelAddCard.vue?vue&type=script&lang=js"
export * from "./ModelAddCard.vue?vue&type=script&lang=js"
import style0 from "./ModelAddCard.vue?vue&type=style&index=0&id=5d72d97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d72d97c",
  null
  
)

export default component.exports